import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

const progress = keyframes`{
    0% {
        opacity: 0;
        bottom: -32px;
    }
    10% {
        opacity: 100%;
        bottom: 0px;
    }
    90% {
        opacity: 100%;
        bottom: 0px;
    }

    100% {
        opacity: 0;
        bottom: -32px;

    }
}`;

export const MessageContainer = styled.div`
  width: 100%;
  min-height: 32px;
  padding: ${({ theme }) => theme.spacing.spacing10} 0;
  background-color: ${({ theme }) => theme.colors.primary};
  position: absolute;
  bottom: 0px;
  z-index: 3;
  display: flex;
  opacity: 0;
  align-items: center;
  animation: ${progress} 2.6s linear;
`;

export const Text = styled.p`
  ${({ theme }) => theme.typography.bodyMedium};
  padding: ${({ theme }) => `0 0 0 ${theme.spacing.spacing40}`};
  margin: 0;
  color: ${({ theme }) => theme.colors.textInversePrimary};
  opacity: 0.92;
`;
